import normalizeMap from './normalizeMap'
import Stopwatch from './Stopwatch'
import { uuidv4 } from './uuidv4'

function formatTimeDiff (ms) {
  console.log('formatTimeDiff', ms)
  let time = ms < 0 ? new Date(-ms) : new Date(ms)
  let result = time.getMinutes() + ':' + ('0' + time.getSeconds()).slice(-2)
  result = (ms < 0 ? '-' : '+') + result
  return result
}

function timeStrToInt (s) {
  if (!s || typeof s !== 'string') return 0
  const m = s.match(/(?:(?:([\d]+):)?([\d]+):)?(\d+)(?:\.(\d+))?/)
  if (!m) return 0
  return parseInt(m[1] || 0) * 60 * 60 * 1000 +
    parseInt(m[2] || 0) * 60 * 1000 +
    parseInt(m[3] || 0) * 1000 +
    parseInt(((m[4] || 0) + '00').slice(0, 3))
}

function formatTime (currentTimeMs, options = {displayHours: true, displayHundredths: true}) {
  let time = new Date(currentTimeMs)

  const display10 = !!options.displayTenths
  const display100 = !!options.displayHundredths
  const displayMinutes = !!options.displayMinutes
  const displayHours = !!options.displayHours

  const milliseconds = display10 || display100 ? '.' + ('00' + time.getMilliseconds()).slice(-3, display100 ? -1 : -2) : ''
  if (!displayHours && !displayMinutes && currentTimeMs < 60 * 1000) {
    // Less than one minute
    return time.getSeconds() + milliseconds
  } else if (!displayHours && currentTimeMs < 60 * 60 * 1000) {
    // Less than one hour
    return time.getMinutes() + ':' + ('0' + time.getSeconds()).slice(-2) + milliseconds
  } else {
    // Greater or equal one hour
    return time.getUTCHours() + ':' + ('0' + time.getMinutes()).slice(-2) + ':' + ('0' + time.getSeconds()).slice(-2) + milliseconds
  }
}

export {
  formatTime,
  formatTimeDiff,
  normalizeMap,
  Stopwatch,
  timeStrToInt,
  uuidv4,
  uuidv4 as uuid
}



// WEBPACK FOOTER //
// ./src/lib/index.js